import http from "./http-common";

class UploadFilesService {
  upload(uid, file, categoryid, filedbid, filename, forceRecent, saveinlib, onUploadProgress) {

    let formData = new FormData();

    formData.append("file", file);
    if (categoryid == null || categoryid == 'null') {
      categoryid = '';
    }
    var url = Vue.prototype.$hostname + "/api/upload/v1/upload?categoryid=" + categoryid + "&filename=" + filename + "&forceRecent=" + forceRecent;
    if (uid != null)
      url += "&uid=" + uid;
    if (filedbid != null)
      url += "&filedbid=" + filedbid;
    if (saveinlib != null)
      url += "&saveinlib=" + saveinlib;
    
    return http.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
  }
  getFolderFiles(id) {
    var url = Vue.prototype.$hostname + "/api/upload/v1/folder/" + id + "/files";
    return http.get(url);
  }

  getFiles(uid, filter) {
    var url = Vue.prototype.$hostname + "/api/upload/v1/files?uid=" + uid;
    if (filter != null && typeof filter != "undefined") {
      url += "&filter=" + filter;
    }
    return http.get(url);
  }

  getFilesAndFolders(uid, filter) {
    var url = Vue.prototype.$hostname + "/api/upload/v1/files/filesandfolders?";
    if (uid != null)
      url += "&url=" + uid;
    if (filter != null && typeof filter != "undefined") {
      url += "&filter=" + filter;
    }
    return http.get(url);
  }

  getFileInfo(id, getuserviews) {
    var url = Vue.prototype.$hostname + "/api/upload/v1/file/info?id=" + id + "&getuserview=" + getuserviews;
    return http.get(url);
  }
}

export default new UploadFilesService();



// WEBPACK FOOTER //
// ./src/components/services/UploadFilesService.js